module.exports = __webpack_public_path__ + "img/PH_1000_R.12375367.png";